<template>
  <div class="page">
    <h1>Spawner service</h1>
  </div>
</template>
